import PieChartIcon from "@mui/icons-material/PieChart";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from '@mui/icons-material/Logout';
import MapIcon from '@mui/icons-material/Map';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Link, useNavigate } from "react-router-dom";
import { updateCurrentUser } from 'firebase/auth';
import {useAuth} from "../Contexts/AuthContexts"
import React from 'react';

const SidebarPage = ({ selectedIndex }) => {
    const [error, setError] = React.useState("")
    const navigate = useNavigate();
    const provider = useAuth();
    const [loading, setLoading] = React.useState(false)
    const loginPage = () => {
      navigate("/")
    }
    const newEventPage = () => {
      navigate("/NewEvent")
    }
    const eventsPage = () => {
      navigate("/UserHome")
    }
    const eventMapPage = () => {
      navigate("/EventMap")
    }

    const myEventsPage = () => {
      navigate("/MyEvents")
    }

    async function handleLogout() {
      setError("")
      try {
        await provider.logout()
        loginPage()
      } catch (err) {
        setError(JSON.stringify(err, Object.getOwnPropertyNames(err)))
      }
    }


  return (
    <div className="bg-[#042534] w-[255px]">
      <h2 className="bg-[#042534] font-bold text-white text-[24px] px-[22px] pt-[22px]">Objects-Des-9</h2>
      <h2 className="bg-[#042534] font-normal text-white text-[16px] px-[22px] pb-[22px]">{provider.currentUser.email}</h2>
      <div className="bg-[#042534]">
        <button
          type="button"
          className="grid grid-cols-4 w-[255px] py-[20px] px-[24px]"
          style={
            selectedIndex === 0
              ? {
                  backgroundColor: "rgb(159, 162, 180, 0.1)",
                  borderLeft: "3px solid white",
                }
              : undefined
          }
          onClick={eventsPage}
        >
          <PieChartIcon
            className="bg-[#042534] w-full"
            style={{ color: selectedIndex === 0 ? "#FFFFFF" : "#9FA2B4" }}
          />
          <span
            className="bg-[#042534] text-left font-size-[16px] col-span-3 bg-opacity-10"
            style={{ color: selectedIndex === 0 ? "#DDE2FF" : "#A4A6B3" }}
          >
            Event List
          </span>
        </button>

        <button
          type="button"
          className="grid grid-cols-4 w-[255px] py-[20px] px-[24px]"
          style={
            selectedIndex === 3
              ? {
                  backgroundColor: "rgb(159, 162, 180, 0.1)",
                  borderLeft: "3px solid white",
                }
              : undefined
          }
          onClick={eventMapPage}
        >
          <MapIcon
            className="bg-[#042534] w-full"
            style={{ color: selectedIndex === 3 ? "#FFFFFF" : "#9FA2B4" }}
          />
          <span
            className="bg-[#042534] text-left font-size-[16px] col-span-3 bg-opacity-10"
            style={{ color: selectedIndex === 3 ? "#DDE2FF" : "#A4A6B3" }}
          >
            Event Map
          </span>
        </button>

        <button
          type="button"
          className="grid grid-cols-4 w-[255px] py-[20px] px-[24px]"
          style={
            selectedIndex === 4
              ? {
                  backgroundColor: "rgb(159, 162, 180, 0.1)",
                  borderLeft: "3px solid white",
                }
              : undefined
          }
          onClick={myEventsPage}
        >
          <PeopleIcon
            className="bg-[#042534] w-full"
            style={{ color: selectedIndex === 3 ? "#FFFFFF" : "#9FA2B4" }}
          />
          <span
            className="bg-[#042534] text-left font-size-[16px] col-span-3 bg-opacity-10"
            style={{ color: selectedIndex === 3 ? "#DDE2FF" : "#A4A6B3" }}
          >
            My Events
          </span>
        </button>


        <button
          type="button"
          className="grid grid-cols-4 w-[255px] py-[20px] px-[24px]"
          style={
            selectedIndex === 1
              ? {
                  backgroundColor: "rgb(159, 162, 180, 0.1)",
                  borderLeft: "3px solid white",
                }
              : undefined
          }
          onClick={newEventPage}
        >
          <AddCircleIcon
            className="bg-[#042534] w-full"
            style={{ color: selectedIndex === 1 ? "#FFFFFF" : "#9FA2B4" }}
          />
          <span
            className="bg-[#042534] text-left font-size-[16px] col-span-3 bg-opacity-10"
            style={{ color: selectedIndex === 1 ? "#DDE2FF" : "#A4A6B3" }}
          >
            Create Event
          </span>
        </button>
        <button
          type="button"
          className="grid grid-cols-4 w-[255px] py-[20px] px-[24px]"
          style={
            selectedIndex === 2
              ? {
                  backgroundColor: "rgb(159, 162, 180, 0.1)",
                  borderLeft: "3px solid white",
                }
              : undefined
          }
          onClick={handleLogout}
        >
          <LogoutIcon
            className="bg-[#042534] w-full"
            style={{ color: selectedIndex === 1 ? "#FFFFFF" : "#9FA2B4" }}
          />
          <span
            className="bg-[#042534] text-left font-size-[16px] col-span-3 bg-opacity-10"
            style={{ color: selectedIndex === 1 ? "#DDE2FF" : "#A4A6B3" }}
          >
            Logout
          </span>
        </button>
      </div>
      <h2 className="bg-[#042534] font-bold text-white text-[24px] p-[350px]"></h2>
    </div>
  )
}

export default SidebarPage;
